import {isMaxUser} from "../utils";

const validateMaxCartQuantity = (quantity) => {
    return quantity && parseFloat(quantity) > 0.01 && parseFloat(quantity) <= 30000.0;
};

const validateRetailCartQuantity = (quantity) => {
    return quantity && isInt(quantity) && parseInt(quantity) >= 1 && parseInt(quantity) <= 30000;
};

const isInt = (value) => {
    let x;
    return isNaN(value) ? !1 : (x = parseFloat(value), (0 | x) === x);
};

const quantityDomElement = (product) => {
    return product.querySelector(".product-tile__qty-field-container .product-tile__qty-field");
};

export const isValidQuantity = (product) => {
    let quantity = quantityDomElement(product).value;

    if (isMaxUser(window)) {
        return validateMaxCartQuantity(quantity);
    } else {
        return validateRetailCartQuantity(quantity)
    }
};

export const getQuantity = (product) => {
    return isValidQuantity(product) ? quantityDomElement(product).value : null;
};

const showError = (product, event) => {
    event.target.classList.add("error");
    product.querySelector(".product-tile__qty-error").classList.add("show-error");
};

const clearError = (product, event) => {
    event.target.classList.remove("error");
    product.querySelector(".product-tile__qty-error").classList.remove("show-error");
};

const roundQuantity = (product, event) => {
    event.target.value = Math.round(getQuantity(product) * 100) / 100;
};

const validateQuantity = (product, event) => {
    const quantity = quantityDomElement(product).value;
    if(!quantity) {
        event.target.value = 1;
    }
    else {
        if (isValidQuantity(product)) {
            roundQuantity(product, event);
            clearError(product, event);
        } else {
            showError(product, event);
        }
    }
};

const bindQuantityChangeEvent = (product) => {
    product.querySelector(".product-tile__qty-field-container .product-tile__qty-field").addEventListener("change", event => {
        validateQuantity(product, event);
    });
};

const bindQuantityBtnIncClickEvent = (product) => {
    product.querySelector(".product-tile__qty-switch--js-inc").addEventListener("click", event => {
        validateQuantity(product, event);
    });
};

const bindQuantityBtnDecClickEvent = (product) => {
    product.querySelector(".product-tile__qty-switch--js-dec").addEventListener("click", event => {
        validateQuantity(product, event);
    });
};

export const initQuantityValidation = (win: WindowProxy) => {
    try {
        const products: HTMLElement = win.document.querySelectorAll(`.product-tile`);

        products.forEach((product: HTMLElement) => {
            bindQuantityChangeEvent(product);
            bindQuantityBtnIncClickEvent(product);
            bindQuantityBtnDecClickEvent(product);
        });
    } catch (e) {
        // console.error(e);
    }
};